export { default as ResultsContent } from './ResultsContent';
